import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import { darkBlue, mainBlue } from 'utils/constants/ColorTheme'

const Span = styled('span')(() => ({
    color: darkBlue,
    fontWeight: 'bold',
    marginLeft: '1.2rem',
    fontSize: '14px',
    height: '19px',
}))

const FieldLabel = ({
    label,
    required,
}) => {
    return (
        <Span>
            {label}
            {required && (<span style={{ color: mainBlue, marginLeft: '5px' }}>*</span>)}
        </Span>
    )
}

FieldLabel.propTypes = {
    label: PropTypes.string,
    required: PropTypes.bool,
}

export default FieldLabel